import '../components/homepage/HomePage.css';

import { Helmet } from 'react-helmet-async';
import HomePageBanner from '../components/homepage/HomePageBanner';
import HomePagePanel from '../components/homepage/HomePagePanel';

const HomePage = () => {
    return (
        <div>
            <Helmet>
                <title>Room 49 - Co-working and shared office space in Tunbridge Wells</title>
                <meta name="description" content="Premium co-working and shared office space in St John's, Tunbridge Wells. A calm, design-led workspace you can book by the day or month." />
                <link rel="canonical" href='https://thetypingrooms.co.uk' />
            </Helmet>
            <HomePageBanner />
            <div className='page'>
                <HomePagePanel />
            </div>
        </div>
    );
};

export default HomePage;
